export const anatomyModule = {
  id: "anatomy",
  title: "Liver Anatomy",
  sections: [
    {
      type: "text",
      content: `<h3>Liver Anatomy</h3>
      The liver is the largest organ in the abdomen. It is made up of two
      liver lobes (right and left) and has a smooth darkbrown surface. 
      It measures about X height, X width and X depth, and weighs about X gr.

      
      <div class="highlight-box">
          <strong>Quick Facts:</strong>
          <ul>
            <li>📏 Size: About X cm long and X cm wide</li>
            <li>⚖️ Weight: X grams </li>
            <li>📍 Location: On the right side of the body, right beneath the 
            diaphragm, under ribs X to Z.</li>
            <li>🎨 Color: Darkbrown in appearance</li>
          </ul>
        </div>

      
        ,`,

      image: "/images/liver/Liver1.png",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "text",
      content: "",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
  ],
};
